// How a Torrebus arrival row is worded, on /torrebus and on the home «Parada más cercana» card.
//
// The server (/api/torrebus/arrivals/{code}) counts each estimate down by its age and, when its
// copy is older than 3 minutes, sends `tiempo: null` (and `stale: true`) rather than minutes
// that are no longer true. Upstream's own "no estimate" answer — «Estimación superior a 90
// minutos, consulte más tarde» — comes as a message row. Both pages used to turn any text longer
// than 15 characters into «Sin servicio», which says the opposite: buses run, just not within
// 90 minutes.

/** The label for an arrival's time: '7 min', 'Más de 90 min', upstream's message, or null
 *  when there is nothing true to say (stale copy). */
export function arrivalLabel(arr) {
  if (!arr || arr.tiempo == null) return null;
  const msg = arr.message || (arr.segundos >= 99999 ? arr.tiempo : null);
  if (msg) {
    const m = /superior a (\d+)\s*minutos/i.exec(msg);
    return m ? `Más de ${m[1]} min` : msg;
  }
  return arr.tiempo;
}

/** True for a real countdown ("7 min"), false for messages and stale rows. */
export const isEstimate = (arr) => !!arr && arr.tiempo != null && !arr.message && arr.segundos < 99999;
